import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { LiveTvIcon } from 'src/domains/layouts/shared/assets/icons/LiveTvIcon';

interface MatchLeadViewToggleButtonPropsType {
    isActive: boolean;
}

export const MatchLeadViewToggleWrapper = styled('div', { label: 'MatchLeadViewToggleWrapper' })`
    display: flex;
    justify-content: center;
    padding: 12px 16px 8px;
    width: 100%;
`;

export const MatchLeadViewToggleTrack = withConfig(theme => styled('div', { label: 'MatchLeadViewToggleTrack' })`
    align-items: center;
    background-color: ${theme.star.overlay.bgColor};
    border-radius: ${theme.star.radius.circular};
    display: inline-flex;
    gap: 2px;
    padding: 2px;
`);

export const MatchLeadViewToggleButton = withConfig(theme => styled('button', { label: 'MatchLeadViewToggleButton' })<MatchLeadViewToggleButtonPropsType>`
    align-items: center;
    appearance: none;
    background-color: ${({ isActive }): string =>
        isActive === true ? theme.star.racingNextOff.toggle.borderColor : 'transparent'};
    border: 0;
    border-radius: ${theme.star.radius.circular};
    color: ${theme.star.stream.txtColor};
    cursor: pointer;
    display: inline-flex;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.medium};
    gap: 6px;
    justify-content: center;
    line-height: 1.2;
    min-height: 32px;
    opacity: ${({ isActive }): string => (isActive === true ? '1' : '0.72')};
    padding: 6px 14px;
    white-space: nowrap;

    &:focus {
        outline: none;
    }
`);

export const MatchLeadWatchLiveIcon = withConfig(theme => styled(LiveTvIcon, { label: 'MatchLeadWatchLiveIcon' })`
    fill: ${theme.star.watchLiveButton.bgColor};
    flex-shrink: 0;
    width: 14px;
`);
